export const STALE_JWT_THRESHOLD_SECONDS = 5 * 60;
const decodeJwtTtlSeconds = (jwt)=>{
    const parts = jwt.split('.');
    if (parts.length !== 3) {
        return null;
    }
    try {
        const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
        if (typeof payload.exp !== 'number' || typeof payload.iat !== 'number') {
            return null;
        }
        return payload.exp - payload.iat;
    } catch (unused) {
        return null;
    }
};
export const secondsUntilJwtStale = (jwt, receivedAtMs, nowMs)=>{
    if (jwt == null || receivedAtMs == null) {
        return null;
    }
    const ttlSeconds = decodeJwtTtlSeconds(jwt);
    if (ttlSeconds == null) {
        return null;
    }
    const elapsedSeconds = Math.floor((nowMs - receivedAtMs) / 1000);
    return ttlSeconds - elapsedSeconds;
};
